import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { api, primeCsrf } from './api';

export type Invitation = {
  id: number;
  email: string;
  name: string;
  role: string;
  client_id: number | null;
  expires_at: string;
  created_at: string;
};

const KEY = ['invitations'] as const;

export function useInvitations() {
  return useQuery({
    queryKey: KEY,
    queryFn: async (): Promise<Invitation[]> => {
      const { data } = await api.get<Invitation[]>('/v1/invitations');
      return data;
    },
  });
}

export function useCreateInvitation() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (payload: {
      email: string;
      name: string;
      role: string;
      client_id?: number | null;
      /** The admin's wording from the composer; blank keeps the standard text. */
      subject?: string;
      message?: string;
    }) => {
      await primeCsrf();
      const { data } = await api.post('/v1/invitations', payload);
      return data;
    },
    onSuccess: () => qc.invalidateQueries({ queryKey: KEY }),
  });
}

export function useRevokeInvitation() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (id: number) => {
      await primeCsrf();
      await api.delete(`/v1/invitations/${id}`);
    },
    onSuccess: () => qc.invalidateQueries({ queryKey: KEY }),
  });
}
